import Link from 'modules/common/Link';
import Portals from 'modules/common/Portals';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {compose, withStateHandlers} from 'recompose';
import {h80} from './styles.scss';

const ModalProjectHistory = ({
  projectPath,
  submissionPath,
  title,
  children,
  modalVisible,
  toggleModal,
}) => (
  <div>
    <Link
      className="pointer blue animate hover-dark-blue"
      to={submissionPath}
      onClick={toggleModal}
    >
      {title}
    </Link>
    {modalVisible && (
      <Portals>
        <div className="flex items-center justify-center fixed h-100 w-100 top-0 left-0 bg-black-90 z-9999">
          <Link
            className="h-100 w-100"
            to={projectPath}
            onClick={toggleModal}
          />
          <div
            className={`tc w5 ${h80} overflow-y-scroll w-90 w-70-m w-70-l absolute center-absolute br2 bg-white`}
          >
            <>
              <div className="tl pa4">
                <Link
                  className="fw6 pointer blue animate hover-dark-blue"
                  to={projectPath}
                  onClick={toggleModal}
                >
                  <FormattedMessage id="close" />
                </Link>
              </div>
              <div className="pv2">{children}</div>
            </>
          </div>
        </div>
      </Portals>
    )}
  </div>
);

ModalProjectHistory.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  modalVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  submissionPath: PropTypes.string.isRequired,
  projectPath: PropTypes.string.isRequired,
};
const enhance = compose(
  withStateHandlers(
    {modalVisible: false},
    {
      toggleModal: ({modalVisible}) => () => ({modalVisible: !modalVisible}),
    },
  ),
);
export default enhance(ModalProjectHistory);
